import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
const { LOGIN, REGISTER } = authModalLoader.constants;

import styles from './styles/CartEmptyWrapper.scss';

function showAuthModal(e, action) {
    e.preventDefault();
    authModalLoader.show({
        action,
        ga: { label: 'cart link' },
    });
}

const links = [
    {
        label: (
            <FormattedMessage
                id="CartEmptyWrapper.links.furniture"
                defaultMessage="Browse Furniture"
            />
        ),
        url: '/furniture/',
    },
    {
        label: (
            <FormattedMessage id="CartEmptyWrapper.links.fashion" defaultMessage="Browse Fashion" />
        ),
        url: '/fashion/',
    },
    {
        label: (
            <FormattedMessage
                id="CartEmptyWrapper.links.jewelry"
                defaultMessage="Browse Jewelry & Watches"
            />
        ),
        url: '/jewelry/',
    },
    {
        label: (
            <FormattedMessage id="CartEmptyWrapper.links.art" defaultMessage="Browse Fine Art" />
        ),
        url: '/art/',
    },
];

export function CartEmptyWrapper({ hasUserId }) {
    return (
        <div className={styles.wrapper}>
            <div className={styles.message} data-tn="cart-empty-message">
                {hasUserId ? (
                    <FormattedMessage id="CartEmpty.empty" defaultMessage="Your cart is empty." />
                ) : (
                    <React.Fragment>
                        <a href="#login" onClick={e => showAuthModal(e, LOGIN)}>
                            <FormattedMessage
                                id="CartEmpty.loggedOut.logIn"
                                defaultMessage="Log in"
                            />
                        </a>{' '}
                        <FormattedMessage id="CartEmpty.loggedOut.or" defaultMessage="or" />{' '}
                        <a href="#register" onClick={e => showAuthModal(e, REGISTER)}>
                            <FormattedMessage
                                id="CartEmpty.loggedOut.register"
                                defaultMessage="register"
                            />
                        </a>{' '}
                        <FormattedMessage
                            id="CartEmpty.loggedOut.toView"
                            defaultMessage="to view your cart"
                        />
                    </React.Fragment>
                )}
            </div>
            <div className={styles.linkContainer}>
                {links.map(({ url, label }) => {
                    return (
                        <a key={url} href={url} className={styles.link} data-tn="cart-empty-link">
                            {label}
                        </a>
                    );
                })}
            </div>
        </div>
    );
}

CartEmptyWrapper.propTypes = {
    hasUserId: PropTypes.bool.isRequired,
};
